import { CHANGED_OPERATORS, COMPARISON_OPERATORS, EQUALS_OPERATORS, IN_OPERATORS, IS_OPERATORS, LIKE_OPERATORS, LIST_OPERATORS, OPERATORS, WAS_IN_OPERATORS, WAS_OPERATORS } from '../../constants';
// Guards

export var isOperator = function isOperator(operator) {
  return OPERATORS.includes(operator);
};
export var isEqualsOperator = function isEqualsOperator(operator) {
  return EQUALS_OPERATORS.includes(operator);
};
export var isLikeOperator = function isLikeOperator(operator) {
  return LIKE_OPERATORS.includes(operator);
};
export var isComparisonOperator = function isComparisonOperator(operator) {
  return COMPARISON_OPERATORS.includes(operator);
};
export var isInOperator = function isInOperator(operator) {
  return IN_OPERATORS.includes(operator);
};
export var isIsOperator = function isIsOperator(operator) {
  return IS_OPERATORS.includes(operator);
};
export var isWasOperator = function isWasOperator(operator) {
  return WAS_OPERATORS.includes(operator);
};
export var isWasInOperator = function isWasInOperator(operator) {
  return WAS_IN_OPERATORS.includes(operator);
};
export var isChangedOperator = function isChangedOperator(operator) {
  return CHANGED_OPERATORS.includes(operator);
};
export var isListOperator = function isListOperator(operator) {
  return LIST_OPERATORS.includes(operator);
};